var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackOverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_11936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0.14209C11.2893 0.14209 0.14209 11.2893 0.14209 25C0.14209 38.7108 11.2893 49.858 25 49.858C38.7108 49.858 49.858 38.7108 49.858 25C49.858 11.2893 38.7108 0.14209 25 0.14209Z",
    fill: "#F48024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0109 29.6593L18.3 27.9403L18.7059 25.3354L30.1577 27.5719L30.0109 29.6593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2182 26.8878L19.8546 21.9762L20.8046 19.8713L31.1682 24.7829L30.2182 26.8878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6 24.2566L22.7909 16.8016L24.2591 15.0474L33.0682 22.5025L31.6 24.2566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5909 12.7671L28.4045 11.3638L35.2273 20.6606L33.4136 22.064L26.5909 12.7671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0455 33.115H17.9546V30.4838H30.0455V33.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7727 27.8524V34.8689H16.2273V27.8524H13.6364V37.5001H34.3636V27.8524H31.7727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_11936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackOverflow);
export default __webpack_public_path__ + "static/media/Stack Overflow.b8c070daab576a6ec14ad98266671b53.svg";
export { ForwardRef as ReactComponent };